module.exports = __webpack_public_path__ + "static/img/20kg-min.1c3ec6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weightlifting/20kg-min.png
// module id = GSEH
// module chunks = 1